"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _validate = _interopRequireDefault(require("../validate"));

function onReplace() {
  return (0, _validate["default"])({
    name: 'onReplace',
    realTarget: function realTarget(action) {
      return action.target;
    },
    "do": function _do(action, state) {
      var payload = action.payload,
          index = action.index,
          condition = action.condition,
          target = action.target;
      var array = (0, _toConsumableArray2["default"])(state[target]);
      if (condition) return array.map(function (element) {
        return condition(element) ? payload : element;
      });
      if (index) array[index] = payload;
      return (0, _toConsumableArray2["default"])(array);
    }
  });
}

var _default = onReplace;
exports["default"] = _default;